import CmpProjsAPI from 'js/api/cmpProjs'

export default {

    loadCmpProjHome ({commit}) {
        commit('setCmpProjHomeLoadStatus', 1)

        CmpProjsAPI.loadCmpProjHome()
            .then(resp => {
                commit('setCmpProjHome', resp)
                commit('setCmpProjHomeLoadStatus', 2)
            })
            .catch(err => {
                commit('setCmpProjHome', {})
                commit('setCmpProjHomeLoadStatus', 3)
            })
    },

    saveCmpProjInfo ({commit}, data) {
        commit('resetCmpProjOperat')
        commit('setSaveCmpProjInfoStatus', 1)

        CmpProjsAPI.saveCmpProjInfo(data)
            .then(resp => {
                commit('setAllErrors', {})
                commit('setCmpProjOperat', 'success')
                commit('setCmpProjInfo', resp)
                commit('setSaveCmpProjInfoStatus', 2)
            })
            .catch(err => {
                commit('setCmpProjOperat', data.operat)
                commit('setAllErrors', err.response.data.errors)
                commit('setSaveCmpProjInfoStatus', 3)
            })
    },

    loadCmpProjInfo ({commit}, data) {
        commit('setCmpProjInfoLoadStatus', 1)

        CmpProjsAPI.loadCmpProjInfo(data)
            .then(resp => {
                commit('setCmpProjInfo', resp)
                commit('setCmpProjInfoLoadStatus', 2)
            })
            .catch(err => {
                commit('setCmpProjInfo', {})
                commit('setCmpProjInfoLoadStatus', 3)
            })
    },

    /** 一覧案件情報更新 **/
    changeCmpProjInfoCommon ({commit}, data) {
        commit('resetChangeCmpProjInfoCommon')
        commit('setChangeCmpProjInfoCommonStatus', 1)
        commit('setCmpProjHasChangeForInputBarStatus', 1)

        CmpProjsAPI.changeCmpProjInfoCommon(data)
            .then(resp => {
                commit('setChangeCmpProjInfoCommon', resp)
                commit('setChangeCmpProjInfoCommonStatus', 2)
                commit('setCmpProjHasChangeForInputBarStatus', 2)
            })
            .catch(err => {
                commit('setChangeCmpProjInfoCommonStatus', 3)
            })
    },

    /** 受信日最新化 **/
    // updateCmpProjInfoRecentInDay ({commit}, data) {
    //     commit('setUpdateCmpProjInfoRecentInDayStatus', 1)

    //     InvitesAPI.updateCmpProjInfoRecentInDay(data)
    //         .then(resp => {
    //             if (resp.data.tech) {
    //                 commit('updateCmpProjInfo', resp.data.tech)
    //             }
    //             commit('setUpdateCmpProjInfoRecentInDay', resp)
    //             commit('setUpdateCmpProjInfoRecentInDayStatus', 2)
    //         })
    //         .catch(err => {
    //             commit('setUpdateCmpProjInfoRecentInDayStatus', 3)
    //         })
    // },


    cmpProjOff ({commit}, data) {
        commit('setCmpProjOffStatus', 1)
        commit('setCmpProjHasChangeForInputBarStatus', 1)

        CmpProjsAPI.cmpProjOff(data)
            .then(resp => {
                commit('setCmpProjOffStatus', 2)
                commit('setCmpProjHasChangeForInputBarStatus', 2)
            })
            .catch(err => {
                commit('setCmpProjOffStatus', 3)
            })
    },

    cmpProjDel ({commit}, data) {
        commit('setCmpProjDelStatus', 1)

        CmpProjsAPI.cmpProjDel(data)
            .then(resp => {
                commit('setCmpProjDelStatus', 2)
            })
            .catch(err => {
                commit('setCmpProjDelStatus', 3)
            })
    },

    cmpProjPublic ({commit}, data) {
        commit('setCmpProjPublicStatus', 1)
        commit('setCmpProjHasChangeForInputBarStatus', 1)

        CmpProjsAPI.cmpProjPublic(data)
            .then(resp => {
                commit('setCmpProjPubliced', resp)
                commit('setCmpProjPublicStatus', 2)
                commit('setCmpProjHasChangeForInputBarStatus', 2)
            })
            .catch(err => {
                commit('setCmpProjPubliced', {})
                commit('setCmpProjPublicStatus', 3)
            })
    },

    cmpProjPricePub ({commit}, data) {
        commit('setCmpProjPricePubStatus', 1)
        commit('setCmpProjHasChangeForInputBarStatus', 1)

        CmpProjsAPI.cmpProjPricePub(data)
            .then(resp => {
                commit('setCmpProjPricePubliced', resp)
                commit('setCmpProjPricePubStatus', 2)
                commit('setCmpProjHasChangeForInputBarStatus', 2)
            })
            .catch(err => {
                commit('setCmpProjPricePubliced', {})
                commit('setCmpProjPricePubStatus', 3)
            })
    },

    cmpProjNote ({commit}, data) {
        commit('setCmpProjNoteStatus', 1)
        commit('setCmpProjHasChangeForInputBarStatus', 1)

        CmpProjsAPI.cmpProjNote(data)
            .then(resp => {
                commit('setCmpProjNoted', resp)
                commit('setCmpProjNoteStatus', 2)
                commit('setCmpProjHasChangeForInputBarStatus', 2)
            })
            .catch(err => {
                commit('setCmpProjNoted', {})
                commit('setCmpProjNoteStatus', 3)
            })
    },

    loadLangGraph ({commit}) {
        commit('setCmpLangGraphLoadStatus', 1)

        CmpProjsAPI.loadLangGraph()
            .then(resp => {
                commit('setCmpLangGraph', resp)
                commit('setCmpLangGraphLoadStatus', 2)
            })
            .catch(err => {
                commit('setCmpLangGraph', {})
                commit('setCmpLangGraphLoadStatus', 3)
            })
    },
    

}
